//
//
//
//

import pdmAttributesQuery from '~/apollo/queries/product/pdm-attributes'

export default {
  props: {
    productId: String
  },
  apollo: {
    pdmAttributes: {
      prefetch: true,
      query: pdmAttributesQuery,
      variables () {
        return { documentId: this.productId }
      }
    }
  }
}
